<article class="main-info" role="contentinfo">
    <div class="row">
        <div class="col-12 col-md-5 img-column">
            <img src="./assets/img/Ilustracion_accesorios.png" alt="">
        </div>
        <div class="col-12 col-md-7 px-4">
            <form class="accessories_form">

                @for (item of selectedAccessories(); track item.id; let idx = $index) {
                <fieldset class="group mt-3">
                    <label class="accessory-label" for="accessory-{{idx}}" [class.text-danger]="showAccesoryError()"
                        [class.text-valid]="!showAccesoryError() && hasSelectedAccessory()">
                        *Agrega los accesorios que quieres asegurar:
                    </label>

                    <span class="accessories_input-wrapper">
                        <input type="text" id="accessory-{{idx}}"
                            class="mt-1 form-control estiloPrincipal accessory-input-list"
                            placeholder="Escribe y selecciona uno" autocomplete="off" [(ngModel)]="item.searchTerm"
                            (ngModelChange)="onSearchChange(idx)" (focus)="onFocus(idx)" (blur)="onBlur(idx, $event)"
                            name="accessory-{{idx}}" required />

                        @if (selectedAccessories().length > 1) {
                        <button type="button" class="remove-btn-input" (click)="removeAccessory(item.id)"
                            aria-label="Eliminar accesorio">
                            <img src="./assets/img/svg/Basurero_azul.svg" alt="clear" title="clear-icon" srcset="">

                        </button>
                        }
                        @if(!canAddMoreAccessories()){
                        <img class="icon-search" src="./assets/img/svg/Buscar.svg" alt="search">
                        }

                    </span>

                    @if(item.showDropdown && getAvailableAccessories(item.id, item.searchTerm).length > 0) {
                    <ul class="dropdown">
                        @for (accessory of getAvailableAccessories(item.id, item.searchTerm); track
                        accessory.id) {
                        <li class="dropdown-item" (mousedown)="selectAccessory(idx, accessory)">
                            <p>{{ accessory.name }}</p>
                        </li>
                        }
                    </ul>
                    }
                </fieldset>
                }

                @if(showAccesoryError() && !hasSelectedAccessory()) {
                <fieldset class="group">
                    <small class="error">Debes seleccionar al menos un accesorio para continuar</small>
                </fieldset>
                }

                <button type="button" class="add-btn" (click)="addAccessory()" [disabled]="!canAddMoreAccessories()"
                    [title]="!canAddMoreAccessories() ? 'Debes seleccionar un accesorio antes de agregar otro' : 'Agregar accesorio'"
                    aria-label="Agregar accesorio">
                    +
                </button>

                <fieldset class="group mt-3 mb-5 form-field">
                    <label for="totalValue" class="form-label m-0"
                        [class.text-danger]="showError() && totalValue().trim() === ''"
                        [class.text-valid]="totalValue().trim() !== ''">*Valor total en
                        pesos:</label>

                    <input type="text" id="totalValue" name="totalValue" class="form-control mt-1
                        estiloPrincipal" [class.text-danger]="showError() && totalValue().trim() === ''"
                        placeholder="Ej: $100.000" [ngModel]="totalValue()" (ngModelChange)="handleValueChange($event)"
                        required appCurrencyFormatter />

                    @if(showTenPercentError()) {
                    <small class="error">{{errorMessage()}}</small>
                    }
                    @else if(showError() && totalValue().trim() === '') {
                    <small class="error">{{errorMessage()}}</small>
                    }
                </fieldset>

                @if( !disableUpdatedFile() ){
                <app-file-upload (disableButton)="handleDisabledButton($event)"
                    (filesChanged)="handleFilesUploaded($event)"></app-file-upload>
                }

                <app-button [text]="'Continuar'" [type]="'primary'" [size]="'small'" [witch]="'fullwidth'"
                    [disabled]="!isFormValid()|| disableSubmitButton()" (clicked)="onSubmit()">
                    Continuar
                </app-button>



            </form>
        </div>
    </div>
</article>